<div class="tiroir-container">
  <mat-expansion-panel
    class="mat-elevation-z0"
    [hideToggle]="true"
    [expanded]="isContentExpanded"
    (opened)="displayContent(true)"
    (closed)="displayContent(false)"
  >
    <mat-expansion-panel-header class="tiroir-header" [collapsedHeight]="'3.75rem'" [expandedHeight]="'3.75rem'">
      <mat-panel-title class="tiroir-title">
        <span *ngIf="isContentExpanded; else contentCollapsedLabel">
          {{ 'masquer-tiroir' | translate }}
        </span>
        <ng-template #contentCollapsedLabel>
          {{ label | translate }}
        </ng-template>
        <img
          [ngClass]="{ up: isContentExpanded }"
          src="{{ 'assets/images/fleche-bas.svg' | cheminAbsoluStatique }}"
          alt=""
          width="12"
          height="22"
        />
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-content select="div.tiroir-content"></ng-content>
  </mat-expansion-panel>
</div>
